import "./styles.css";

const termChallengeAyatPage = () => {
  return (
    <div class="about-section">
      <h4>
        Syarat & Ketentuan – Challenge Verse per Day (Tantangan Harian Ayat)
      </h4>
      <p class="line-space">
        Program ini bertujuan untuk menjaga kita selalu berinteraksi dan
        Istiqomah setiap hari membaca Al- Quran Satu Hari Satu Ayat
      </p>
      <span>1. Peserta harus join challenge – Program One Day One Verse</span>
      <p></p>
      <span>
        2. Peserta melakukan tilawah / membaca Al-Quran hanya di Aplikasi Diary
        Muslim
      </span>
      <p></p>
      <span>
        3. Tilawah Al-Quran dilakukan setiap hari dan berurutan dimulai dari
        hari-1 ( Day-1).
      </span>
      <p></p>
      <span>
        4. Peserta yang bisa menyelesaikan sesuai target akan mendapat Badge dan
        Poin
      </span>
      <p></p>
      <span>5. Badge Program yang ditampilkan di user profile :</span>
      <ol type="1">
        <li>
          Badge Emas = untuk peserta yang selesai membaca full 100% sesuai
          periode program tanpa absen
        </li>
        <li>
          Badge Perak = untuk peserta yang selesai membaca 50% target sesuai
          periode program
        </li>
      </ol>
      <p></p>
      <span>
        6. Jumlah poin yang didapat akan dihitung berdasarkan kehadiran mengaji
        per hari-nya, Perhitungan poin seperti berikut :
        <div style={{ marginLeft: 50, marginTop: 8 }}>
          1 hari = 1 ayat = 1 poin
        </div>
        <div style={{ marginLeft: 50 }}>
          Jika, 30 hari hadir membaca x 1 = 30 poin ; 10 hari hadir membaca x 1
          = 10 poin
        </div>
      </span>
      <p></p>
      <span>7. Penukaran poin akan diinformasikan jadwalnya kemudian.</span>
    </div>
  );
};

export default termChallengeAyatPage;
